class TransactionAuthenticationController {
  constructor() {
    'ngInject';
  }
}

export default TransactionAuthenticationController;


// WEBPACK FOOTER //
// ./client/app/pages/settings/component/transaction-authentication/transaction-authentication.controller.js